import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Spinner from "react-bootstrap/Spinner";
import InputLabel from '@mui/material/InputLabel';
import { Icon } from "@iconify/react";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import axios from "axios";
import Checkbox from '@mui/material/Checkbox';
import { Multiselect } from "multiselect-react-dropdown";
import Form from 'react-bootstrap/Form';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Button, IconButton } from '@mui/material';
import settings from "../helpers/Settings";
import * as moment from 'moment';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import CloseIcon from '@mui/icons-material/Close';
import Paper from '@mui/material/Paper';
import AddIcon from '@mui/icons-material/Add';
import Modal from '@mui/material/Modal';
import { Box } from "@mui/material";
let { KayanURL } = settings;
const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid gray',
    borderRadius: '20px',
    boxShadow: 24,
    p: 4,
};

class UpdateClaim extends Component {

    constructor(props) {
        super(props);
        this.state = {
            addDiagnosis: false,
            addProcedure: false,
            oralSlected: false,
            procedures: [],
            diagnosisSequence: [],
            informationSequence: [],
            vitalSignsArray: [],
            supportingInfoarray: [],
            elegibilityOffline: false,
            elegibilityOnline: false,
            vitalSignSelectArray: [],
            allDiagnosisSelect: [],
            defaultValueClaimFlag: false,
            defaultValuePayerIDFlag: false,

            patientid: this.props.selectedClaim[0].patientid,
            insuranceCompanySelect: this.props.selectedClaim[0].payerid,
            allDiagnosis: this.props.selectedClaim[0].diagnosis,
            claimType: this.props.selectedClaim[0].claimtype,
            proceduresforneedaproval: this.props.selectedClaim[0].proceduresforneedaproval,
            category: this.props.selectedClaim[0].category,
            allprocedures: this.props.selectedClaim[0].allprocedures,

        };


    }
    handleUpdateClaim = () => {
        let { allprocedures, proceduresforneedaproval, allDiagnosisSelect, allDiagnosis, category, vitalSignSelectArray } = this.state
        allDiagnosisSelect = []
        vitalSignSelectArray = []
        if (allprocedures && allprocedures.length > 0) {

            let procedures = allprocedures
            const allproceduresRows = procedures.map((element, index) => {
                let found = proceduresforneedaproval.some((item) => JSON.stringify(item) === JSON.stringify(element));
                return (
                    <TableRow
                        key={index}
                    >
                        <TableCell align='center'><Checkbox name="online" defaultChecked={found ? true : false}
                            onChange={(e) => this.handleCheckBox(e, index)}
                        /></TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>{element.code} </TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>{element.description}</TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>{element.price}</TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>{element.quantity}</TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>{element.tax}</TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>{this.state.oralSlected ? element.bodySite : " "}</TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}><IconButton
                            onClick={() => {
                                this.handleDeleteProcedure(index);
                            }}
                        >
                            <Icon color="red" icon="fluent:delete-12-regular" />
                        </IconButton></TableCell>
                    </TableRow>
                );
            });
            this.setState({
                allproceduresRows,
                addProceduretotable: true,
                procedures
            });
        }
        if (allDiagnosis && allDiagnosis.length > 0) {
            // let allDiagnosis = diagnosis
            for (let i = 0; i < allDiagnosis.length; i++) {
                allDiagnosisSelect.push({ "view": allDiagnosis[i].type + " " + allDiagnosis[i].code })
            }
            const allDiagnosisRows = allDiagnosis.map((element, index) => {
                return (
                    <TableRow
                        key={index}
                    >
                        <TableCell align="center" style={{ fontSize: "small" }}>{element.type} </TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}>{element.code}</TableCell>
                        <TableCell align="center" style={{ fontSize: "small" }}><IconButton
                            onClick={() => {
                                this.handleDeleteDiagnosis(index);
                            }}
                        >
                            <Icon color="red" icon="fluent:delete-12-regular" />
                        </IconButton></TableCell>
                    </TableRow>
                );

            });
            this.setState({
                allDiagnosisRows,
                addDiagnosistotable: true,
                allDiagnosis,
                allDiagnosisSelect
            });
        }
        if (category && category.length > 0) {
            let categories = category
            let supportingInfoarray = category
            let vitalSignsArray = []

            for (let i = 0; i < categories.length; i++) {
                let display = Object.keys(categories[i]);
                let valueInfo = categories[i][[display[0]]];
                vitalSignsArray.push({ display: display[0], valueInfo: valueInfo })
                vitalSignSelectArray.push({ display: display[0] + " " + valueInfo, valueInfo: valueInfo })

            }
            
            let diastolic="",systolic="",height="",weight="",daySupply="",reasonForVisit="",birthWeight="";
            let count1=0,count2=0,count3=0,count4=0,count5=0,count6=0,count7=0;
            for(let j=0;j<vitalSignsArray.length;j++){
                if(vitalSignsArray[j].display === 'vital-sign-diastolic'){
                    count1+=1;
                    if(count1>1){
                        diastolic+=','+vitalSignsArray[j].valueInfo;
                    }else{
                        diastolic+=vitalSignsArray[j].valueInfo;
                    }
                }
                if(vitalSignsArray[j].display === 'vital-sign-systolic'){
                    count2+=1;
                    if(count2>1){
                        systolic+=','+vitalSignsArray[j].valueInfo;
                    }else{
                        systolic+=vitalSignsArray[j].valueInfo;
                    }
                  }
                  if(vitalSignsArray[j].display === 'vital-sign-height'){
                    count3+=1;
                    if(count3>1){
                        height+=','+vitalSignsArray[j].valueInfo;
                    }else{
                        height+=vitalSignsArray[j].valueInfo;
                    }
                  }
                  if(vitalSignsArray[j].display === 'vital-sign-weight'){
                    count4+=1;
                    if(count4>1){
                        weight+=','+vitalSignsArray[j].valueInfo;
                    }else{
                        weight+=vitalSignsArray[j].valueInfo;
                    }
                  }
                  if(vitalSignsArray[j].display === 'days-supply'){
                    count5+=1;
                    if(count5>1){
                        daySupply+=','+vitalSignsArray[j].valueInfo;
                    }else{
                        daySupply+=vitalSignsArray[j].valueInfo;
                    }
                  }
                  if(vitalSignsArray[j].display === 'reason-for-visit'){
                    count6+=1;
                    if(count6>1){
                        reasonForVisit+=','+vitalSignsArray[j].valueInfo;
                    }else{
                        reasonForVisit+=vitalSignsArray[j].valueInfo;
                    }
                  }
                  if(vitalSignsArray[j].display === 'birth-weight'){
                    count7+=1;
                    if(count7>1){
                        birthWeight+=','+vitalSignsArray[j].valueInfo;
                    }else{
                        birthWeight+=vitalSignsArray[j].valueInfo;
                    }
                  }
            }
                     this.setState({
                         vitalSignsArray,
                         diastolic,systolic,height,weight,daySupply,reasonForVisit,birthWeight,
                         vitalSignSelectArray,
                         supportingInfoarray
                     });
        }
    }

    componentDidMount = async () => {
        this.getAllPatients();
        this.getAllclaims();
        this.getAllEligibilityInfoRows();
        this.handleUpdateClaim();
    };
    getAllPatients = async () => {
        let Allpatients = await axios.put(
            KayanURL + "api/KSA/RCM/patient/getPatients",
            {}
        );
        if (Allpatients) {
            let { data } = Allpatients;
            if (data) {
                if (data.success) {
                    let allPatients = data.patients
                    let eligiblePatient = allPatients.filter((element) => {
                        return element.id == this.state.patientid;
                    });
                    this.setState({ success: true, patientName: eligiblePatient[0].firstname + " " + eligiblePatient[0].lastname });
                } else {
                    this.setState({ success: false, error: data.error });
                }
            }
        }
    };
    handleSubmitAddNewDiagnosis = async (e) => {
        e.preventDefault();
        let { diagnosis, allDiagnosis, allDiagnosisSelect } = this.state;
        allDiagnosis.push(diagnosis);
        if (!allDiagnosisSelect) {
            for (let i = 0; i < allDiagnosis.length; i++) {
                allDiagnosisSelect.push({ "view": allDiagnosis[i].type + " " + allDiagnosis[i].code })
            }
        }
        else {
            allDiagnosisSelect.push({ "view": diagnosis.type + " " + diagnosis.code })
        }


        const allDiagnosisRows = allDiagnosis.map((element, index) => {
            return (
                <TableRow
                    key={index}
                >
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.type} </TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.code}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}><IconButton
                        onClick={() => {
                            this.handleDeleteDiagnosis(index);
                        }}
                    >
                        <Icon color="red" icon="fluent:delete-12-regular" />
                    </IconButton></TableCell>
                </TableRow>
            );

        });
        this.setState({
            allDiagnosisRows,
            addDiagnosistotable: true,
        });
    };
    handleCloseVital = () => {
        this.setState({ vitalModal: false })
    }
    handleOpenDiagnosis = () => {
        this.setState({ diagnosisModal: true })
    }
    handleCloseDiagnosis = () => {
        this.setState({ diagnosisModal: false })
    }
    handleOpenProcedure = () => {
        this.setState({ procedureModal: true })
    }
    handleCloseProcedure = () => {
        this.setState({ procedureModal: false })
    }
    getAllEligibilityInfoRows = async () => {
        let eligibilityInfo = await axios.put(
            KayanURL + "api/KSA/RCM/patient/getEligibilityInfo",
            {}
        );
        if (eligibilityInfo) {
            let { data } = eligibilityInfo;
            // console.log(data)
            if (data) {
                if (data.success) {
                    this.setState({ success: true, eligibilityInfo: data.allEligibilityInfoRows });
                } else {
                    this.setState({ success: false, error: data.error, eligibilityInfo: data.allEligibility })
                }
            }
        }
    }
    handleUpdate = async (e) => {
        e.preventDefault();
        let { supportingInfoarray,
        } = this.state;
        let Response = await axios.put(
            KayanURL + "api/KSA/RCM/Claim/updateClaim",
            {
                payerID: this.state.insuranceCompanySelect,
                providerID: "10000300178702",
                patientID: this.state.patientid,
                supportingInformation: JSON.stringify(supportingInfoarray),
                claimType: this.state.claimType,
                diagnosis: JSON.stringify(this.state.allDiagnosis),
                procedures: this.state.proceduresforneedaproval ? JSON.stringify(this.state.proceduresforneedaproval) : '',
                allProcedures: JSON.stringify(this.state.procedures),
            }
        );
        if (Response) {
            let { data } = Response;
            if (data) {
                if (data.success) {
                    this.setState({ success: true });
                    this.props.closeModal();
                } else {
                    this.setState({ success: false, error: data.error });
                }
            }
        }
    };
    getAllclaims = async () => {
        let Allclaims = await axios.put(
          KayanURL + "api/KSA/RCM/Claim/getAllClaim",
          {}
        );
        if (Allclaims) {
          let { data } = Allclaims;
          if (data) {
            if (data.success) {
              this.setState({ success: true, allClaims: data.claims });
            } else {
              this.setState({ success: false, error: data.error, allClaims: data.claims });
            }
          }
        }
      };
    handleDeleteDiagnosis = (index) => {
        let { allDiagnosis } = this.state;
        allDiagnosis.splice(index, 1);
        const allDiagnosisRows = allDiagnosis.map((element, index) => {
            return (
                <TableRow
                    key={index}

                >
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.type} </TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.code}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}><IconButton
                        onClick={() => {
                            this.handleDeleteDiagnosis(index);
                        }}
                    >
                        <Icon color="red" icon="fluent:delete-12-regular" />
                    </IconButton></TableCell>
                </TableRow>
            );
        });
        this.setState({ allDiagnosisRows });
        if (JSON.stringify(allDiagnosis) == "[]") {
            this.setState({ addDiagnosistotable: false });
        }
    };
    HandleDateChange = (e) => {
        let date = moment(e.value.$d).format('YYYY-MM-DD')
        this.setState({ [e.name]: date })
    }
    HandleDiagnosisChange = (e) => {
        this.setState({
            diagnosis: { ...this.state.diagnosis, [e.target.name]: e.target.value },
        });
    };
    HandleInputTextChange = (e) => {
        let { allPatients, eligibilityInfo, allClaims,
            allDiagnosisSelect, vitalSignSelectArray } = this.state;
        let name = e.target.name;
        let value = e.target.value;
        this.setState({ [name]: value });
        
        if (name == "insuranceCompanySelect") {
            this.setState({ defaultValuePayerIDFlag: false })
        } else if (name == 'claimType') {
            this.setState({ defaultValueClaimFlag: false })
        }
        if (value == "oral") {
            this.setState({ oralSlected: true });
        } else {
            this.setState({ oralSlected: false });
        }

    };
    HandleProcedureChange = (e) => {
        let { informationSequence, diagnosisSequence } = this.state;
        if (this.state.oralSlected) {
            let bodySiteInfo = e.target.value.split("-");
            this.setState({
                procedure: {
                    ...this.state.procedure,
                    [e.target.name]: bodySiteInfo[0],
                    bodySiteDisplay: bodySiteInfo[1],
                },
            });
        } else {
            this.setState({
                procedure: {
                    ...this.state.procedure,
                    [e.target.name]: e.target.value,
                },
            });
        }
    };
    HandleVitalSignChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;

        if (value) {
            name = value;
            this.setState({ vitalModal: true, vitalSignSelected: true, selectedName: value });
            if (value == "reason-for-visit") {
                this.setState({ reasonForVisitSelected: true });
            } else {
                this.setState({ reasonForVisitSelected: false });
            }
        } else {
            this.setState({ vitalModal: false, vitalSignSelected: false });
        }
    };
    handleSubmitAddNewProcedure = async (e) => {
        e.preventDefault();
        let { procedure, procedures } = this.state;
        procedures.push(procedure);
        const allproceduresRows = procedures.map((element, index) => {
            return (

                <TableRow
                    key={index}
                >
                    <TableCell align='center'><Checkbox name="online"
                        onChange={(e) => this.handleCheckBox(e, index)}
                    /></TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.code} </TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.description}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.price}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.quantity}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.tax}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{this.state.oralSlected ? element.bodySite : " "}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}><IconButton
                        onClick={() => {
                            this.handleDeleteProcedure(index);
                        }}
                    >
                        <Icon color="red" icon="fluent:delete-12-regular" />
                    </IconButton></TableCell>
                </TableRow>
            );
        });
        this.setState({
            allproceduresRows,
            addProceduretotable: true,
        });

    };
    handleCheckBox = async (e, index) => {
        let { procedures, proceduresforneedaproval } = this.state;
        if (e.target.checked) {
            proceduresforneedaproval.push(procedures[index]);
        } else {
            proceduresforneedaproval.splice(index, 1);
        }
    };
    handleDeleteProcedure = (index) => {
        let { procedures,
            proceduresforneedaproval
        } = this.state;
        if (proceduresforneedaproval && proceduresforneedaproval.length > 0) {
            if (proceduresforneedaproval.includes(procedures[index])) {
                let i = proceduresforneedaproval.indexOf(procedures[index]);
                proceduresforneedaproval.splice(i, 1);
            }
        }
        // console.log(proceduresforneedaproval, "dddddddd")
        procedures.splice(index, 1);
        const allproceduresRows = procedures.map((element, index) => {
            return (
                <TableRow
                    key={index}
                >
                    <TableCell align='center'><Checkbox name="online"
                        onChange={(e) => this.handleCheckBox(e, index)}
                    /></TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.code} </TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.description}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.price}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.quantity}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{element.tax}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>{this.state.oralSlected ? element.bodySite : " "}</TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}><IconButton
                        onClick={() => {
                            this.handleDeleteProcedure(index);
                        }}
                    >
                        <Icon color="red" icon="fluent:delete-12-regular" />
                    </IconButton></TableCell>
                </TableRow>
            );
        });
        this.setState({ allproceduresRows });
        if (JSON.stringify(procedures) == "[]") {
            this.setState({ addProceduretotable: false });
        }
    };
    handleCheckBoxChange = (e) => {
        if (e.target.name == "online") {
            if (e.target.checked) {
                this.setState({ elegibilityOnline: true });
            } else {
                this.setState({ elegibilityOnline: false });
            }
        } else if (e.target.name == "offline") {
            if (e.target.checked) {
                this.setState({ elegibilityOffline: true });
            } else {
                this.setState({ elegibilityOffline: false });
            }
        }
    };
    HandleSupportingInfoChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        let { selectedName } = this.state;
        this.setState({
            vitalSignJson: { display: selectedName, valueInfo: value },
            vitalSignSelectJson: { display: selectedName + " " + value, valueInfo: value }
        });

    };
    handleConfirm = async (e) => {
        e.preventDefault();
        let { supportingInfoarray, vitalSignsArray, vitalSignJson, vitalSignSelectJson, vitalSignSelectArray } = this.state;
        supportingInfoarray.push({
            [vitalSignJson.display]: vitalSignJson.valueInfo,
        });
        vitalSignsArray.push(vitalSignJson);
        vitalSignSelectArray.push(vitalSignSelectJson)

        let diastolic="",systolic="",height="",weight="",daySupply="",reasonForVisit="",birthWeight="";
        let count1=0,count2=0,count3=0,count4=0,count5=0,count6=0,count7=0;
        for(let j=0;j<vitalSignsArray.length;j++){
            if(vitalSignsArray[j].display === 'vital-sign-diastolic'){
                count1+=1;
                if(count1>1){
                    diastolic+=','+vitalSignsArray[j].valueInfo;
                }else{
                    diastolic+=vitalSignsArray[j].valueInfo;
                }
            }
            if(vitalSignsArray[j].display === 'vital-sign-systolic'){
                count2+=1;
                if(count2>1){
                    systolic+=','+vitalSignsArray[j].valueInfo;
                }else{
                    systolic+=vitalSignsArray[j].valueInfo;
                }
              }
              if(vitalSignsArray[j].display === 'vital-sign-height'){
                count3+=1;
                if(count3>1){
                    height+=','+vitalSignsArray[j].valueInfo;
                }else{
                    height+=vitalSignsArray[j].valueInfo;
                }
              }
              if(vitalSignsArray[j].display === 'vital-sign-weight'){
                count4+=1;
                if(count4>1){
                    weight+=','+vitalSignsArray[j].valueInfo;
                }else{
                    weight+=vitalSignsArray[j].valueInfo;
                }
              }
              if(vitalSignsArray[j].display === 'days-supply'){
                count5+=1;
                if(count5>1){
                    daySupply+=','+vitalSignsArray[j].valueInfo;
                }else{
                    daySupply+=vitalSignsArray[j].valueInfo;
                }
              }
              if(vitalSignsArray[j].display === 'reason-for-visit'){
                count6+=1;
                if(count6>1){
                    reasonForVisit+=','+vitalSignsArray[j].valueInfo;
                }else{
                    reasonForVisit+=vitalSignsArray[j].valueInfo;
                }
              }
              if(vitalSignsArray[j].display === 'birth-weight'){
                count7+=1;
                if(count7>1){
                    birthWeight+=','+vitalSignsArray[j].valueInfo;
                }else{
                    birthWeight+=vitalSignsArray[j].valueInfo;
                }
              }
        }
        this.setState({
            vitalSignsArray,
            diastolic,systolic,height,weight,
            daySupply,reasonForVisit,birthWeight,
            vitalSignSelectArray,
            vitalModal:false,

        });
    };
    onSelectDiagnosis = (selectedList) => {
        let { allDiagnosisSelect, } = this.state
        let Values = [];
        selectedList.forEach((item) => {
            Values.push(allDiagnosisSelect.indexOf(item) + 1);
        });

        this.setState({
            procedure: {
                ...this.state.procedure,
                diagnosisSequence: Values,
            },
        })
    }
    onRemoveDiagnosis = (selectedList, removedItem) => {

        let { allDiagnosisSelect } = this.state
        let Values = [];
        selectedList.forEach((item) => {
            if (allDiagnosisSelect.indexOf(item) + 1 != allDiagnosisSelect.indexOf(removedItem) + 1) {
                Values.push(allDiagnosisSelect.indexOf(item) + 1);
            }
        });
        this.setState({
            procedure: {
                ...this.state.procedure,
                diagnosisSequence: Values,
            },
        })
    }
    onSelectCategory = (selectedList) => {

        let { vitalSignSelectArray } = this.state
        let Values = [];
        selectedList.forEach((item) => {
            Values.push(vitalSignSelectArray.indexOf(item) + 1);
        });
        this.setState({
            procedure: {
                ...this.state.procedure,
                informationSequence: Values,
            },
        })
    }
    onRemoveCategory = (selectedList, removedItem) => {
        let { vitalSignSelectArray } = this.state
        let Values = [];
        selectedList.forEach((item) => {
            if (vitalSignSelectArray.indexOf(item) + 1 != vitalSignSelectArray.indexOf(removedItem) + 1) {
                Values.push(vitalSignSelectArray.indexOf(item) + 1);
            }
        });
        this.setState({
            procedure: {
                ...this.state.procedure,
                informationSequence: Values,
            },
        })
    }

    render() {
        let { allPatients, supportingInfoarray, vitalSignSelectArray } = this.state;
        let patientRows;
        if (allPatients && allPatients.length > 0) {

            patientRows = allPatients.map((element, index) => {
                return (
                    <MenuItem key={index} value={element.id} style={{ fontSize: "small" }}>{element.firstname + " " + element.lastname}</MenuItem>
                );
            });


        }
        return (
            <div>
                <div style={{ width: "90%", margin: "auto", padding: "7px" }}>
                    <FormControl style={{ width: "100%" }}>
                        <Container>
                            <Row>
                                <Col>
                                    <FormControl fullWidth sx={{ mb: 3 }} >
                                        <InputLabel id="patient" style={{ fontSize: "small" }}>{this.state.patientName ? this.state.patientName : "Patients"}</InputLabel>
                                        <Select
                                            required
                                            labelId="patient"
                                            name="patientName"
                                            label="Patient"
                                            onChange={this.HandleInputTextChange}
                                            style={{ height: "45px" }}
                                        >
                                            {patientRows}
                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth sx={{ mb: 3 }} >
                                        <InputLabel id="insurance" style={{ fontSize: "small" }}>{this.state.insuranceCompanySelect ? this.state.insuranceCompanySelect : "Payer ID"} </InputLabel>
                                        <Select
                                            required
                                            labelId="insurance"
                                            name="insuranceCompanySelect"
                                            label="Insurance Company"
                                            onChange={this.HandleInputTextChange}
                                            style={{ height: "45px" }}
                                        >
                                            <MenuItem value="INS-FHIR" style={{ fontSize: "small" }}>Pseudo Payer</MenuItem>

                                        </Select>
                                    </FormControl>
                                    <FormControl fullWidth sx={{ mb: 3 }}>
                                        <InputLabel id="type" style={{ fontSize: "small" }}>{this.state.claimType ? this.state.claimType : "Claim Type"}</InputLabel>
                                        <Select
                                            required
                                            labelId="type"
                                            name="claimType"
                                            label="Claim Type"
                                            onChange={this.HandleInputTextChange}
                                            style={{ height: "45px" }}
                                        >
                                            <MenuItem value="institutional" style={{ fontSize: "small" }}>Institutional</MenuItem>
                                            <MenuItem value="oral" style={{ fontSize: "small" }}>Oral</MenuItem>
                                            <MenuItem value="pharmacy" style={{ fontSize: "small" }}>Pharmacy</MenuItem>
                                            <MenuItem value="professional" style={{ fontSize: "small" }}>Professional</MenuItem>
                                            <MenuItem value="vision" style={{ fontSize: "small" }}>Vision</MenuItem>
                                        </Select>
                                    </FormControl>

                                </Col>
                                <Col >

                                    <FormControl fullWidth sx={{ mb: 3 }}>
                                        <InputLabel id="category" style={{ fontSize: "small" }}>Supporting Informatiom</InputLabel>
                                        <Select
                                            labelId="supportingInformation"
                                            name="category"
                                            label="supportingInformation"
                                            onChange={this.HandleVitalSignChange}
                                            style={{ height: "45px" }}
                                        >
                                            <MenuItem value="vital-sign-diastolic" style={{ fontSize: "small" }}>Diastolic</MenuItem>
                                            <MenuItem value="vital-sign-systolic" style={{ fontSize: "small" }}>Systolic</MenuItem>
                                            <MenuItem value="vital-sign-height" style={{ fontSize: "small" }}>Height</MenuItem>
                                            <MenuItem value="vital-sign-weight" style={{ fontSize: "small" }}>Weight</MenuItem>
                                            <MenuItem value="days-supply" style={{ fontSize: "small" }}>Days supply</MenuItem>
                                            <MenuItem value="reason-for-visit" style={{ fontSize: "small" }}>reason for visit</MenuItem>
                                            <MenuItem value="birth-weight" style={{ fontSize: "small" }}>Birth weight</MenuItem>
                                        </Select>

                                    </FormControl>
                                   
                                    <div style={{ textAlign: "center" }}>
                                        <Button variant="contained"
                                            style={{
                                                backgroundColor: "rgb(97 110 120",
                                                border: "1px ridge gray",
                                                width: "100%",
                                                boxShadow: "none", height: "45px"
                                            }} onClick={this.handleOpenDiagnosis}><AddIcon style={{ paddingRight: "5px", color: "white" }} /><span style={{ color: "white", fontSize: "small" }}>Add Diagnosis</span></Button>
                                    </div>

                                    <div style={{ textAlign: "center", marginTop: "21px" }}>
                                        <Button variant="contained"
                                            style={{
                                                backgroundColor: "rgb(97 110 120",
                                                border: "1px ridge gray",
                                                width: "100%", boxShadow: "none", height: "45px"
                                            }}>
                                            <AddIcon style={{ paddingRight: "5px", color: "white" }} />
                                            <span style={{ color: "white", fontSize: "13px" }}
                                                onClick={this.handleOpenProcedure}
                                            >Add Procedures</span></Button>
                                    </div>

                                </Col>
                            </Row>

                                        <div fullWidth>
                                            <h3 style={{ fontSize: "18px", color: "gray",
                                             marginTop: "20px", fontWeight: "bold", textAlign: "center" }}>
                                                All Diagnosis
                                            </h3>
                                            <TableContainer component={Paper} style={{ marginTop: "10px", width: "100%"}}>
                                                <Table aria-label="simple table">
                                                    <TableHead style={{ backgroundColor: "#fafafa" }}>
                                                        <TableRow style={{ textAlign: 'center' }}>
                                                            <TableCell align="center">Type</TableCell>
                                                            <TableCell align="center">Code</TableCell>
                                                            <TableCell align="center">Action</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                         {this.state.addDiagnosistotable ? (
                                                    <TableBody>
                                                        {this.state.allDiagnosisRows}
                                                    </TableBody>
                                                
                                    ) : null}
                                    </Table>
                                            </TableContainer>
                                        </div>
                                        
                                        <div fullWidth style={{marginTop: "20px",}}>
                                        <h3 style={{ fontSize: "18px", color: "gray", marginTop: "10px", fontWeight: "bold" ,textAlign:"center"}}>
                                                Supporting Information
                                            </h3>
                                    <TableContainer component={Paper} style={{ marginTop: "10px", width: "100%" }}>
                                        <Table aria-label="simple table">
                                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                                                <TableRow style={{ textAlign: 'center' }}>
                                                    <TableCell align="center">vital-sign-diastolic</TableCell>
                                                    <TableCell align="center">vital-sign-systolic</TableCell>
                                                    <TableCell align="center">vital-sign-height</TableCell>
                                                    <TableCell align="center">vital-sign-weight</TableCell>
                                                    <TableCell align="center">days-supply</TableCell>
                                                    <TableCell align="center">reason-for-visit</TableCell>
                                                    <TableCell align="center">birth-weight</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            {this.state.vitalSignsArray && this.state.vitalSignsArray.length>0 ?(
                                                <TableBody>
                                            <TableCell align="center" style={{fontSize:"small"}}>
                                                {this.state.diastolic}
                                                </TableCell>
                                                <TableCell align="center" style={{fontSize:"small"}}>
                                                {this.state.systolic}
                                                </TableCell>
                                                <TableCell align="center" style={{fontSize:"small"}}>
                                                {this.state.height}
                                                </TableCell>
                                                <TableCell align="center" style={{fontSize:"small"}}>
                                                {this.state.weight}
                                                </TableCell>
                                                <TableCell align="center" style={{fontSize:"small"}}>
                                                {this.state.daySupply}
                                                </TableCell>
                                                <TableCell align="center" style={{fontSize:"small"}}>
                                                {this.state.reasonForVisit}
                                                </TableCell>
                                                <TableCell align="center" style={{fontSize:"small"}}>
                                                {this.state.birthWeight}
                                                </TableCell>
                                            </TableBody>
                                            ):null}
                                            
                                </Table>
                                    </TableContainer>
                                        </div>

                                        <div fullWidth style={{marginTop: "20px"}}>
                                            <h3 style={{ fontSize: "18px", color: "gray", fontWeight: "bold", textAlign: "center" }}>
                                                All Procedures
                                            </h3>
                                            <TableContainer component={Paper} style={{marginTop: "10px", width: "100%" }}>
                                                <Table aria-label="simple table">
                                                    <TableHead style={{ backgroundColor: "#fafafa" }}>
                                                        <TableRow style={{ textAlign: 'center' }}>
                                                            <TableCell align="center"></TableCell>
                                                            <TableCell align="center">Code</TableCell>
                                                            <TableCell align="center">Description</TableCell>
                                                            <TableCell align="center">Price</TableCell>
                                                            <TableCell align="center">Quantity</TableCell>
                                                            <TableCell align="center">Tax</TableCell>
                                                            <TableCell align="center">BodySite</TableCell>
                                                            <TableCell align="center">Action</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                    {this.state.addProceduretotable ? (
                                                    <TableBody>
                                                        {this.state.allproceduresRows}
                                                    </TableBody>
                                                
                                    ) : null}
                                    </Table>
                                            </TableContainer>

                                        </div>

                            <div style={{ margin: "auto", marginTop: "60px", width: "80%", display: "flex", justifyContent: "space-evenly" }}>

                                <Button variant="contained" style={{ backgroundColor: "rgb(97 110 120", width: "150px" }}
                                    onClick={(e) => this.handleUpdate(e)}
                                >Update</Button>


                            </div>
                        </Container>
                    </FormControl>

                </div>

                {this.state.procedureModal ? (
                    <>
                        <Modal
                            open={this.state.procedureModal}
                            onClose={this.handleCloseProcedure}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                        >
                            <Box sx={styleModal}
                                style={{ width: "50%", height: "500px", overflowY: "scroll" }}

                            >


                                <Row>
                                    <Col>
                                    <div style={{width:"287px"}}>
                                    <FormControl fullWidth sx={{ mb: 3 }} >
                                            <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                                                inputProps={{ sx: { padding: "11px" } }} required name="code" label="Code" variant="outlined" onChange={this.HandleProcedureChange} />
                                        </FormControl>
                                        <FormControl fullWidth sx={{ mb: 3 }}>
                                            <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                                                inputProps={{ sx: { padding: "11px" } }} required name="description" label="Description" variant="outlined" onChange={this.HandleProcedureChange} />
                                        </FormControl>
                                        <FormControl fullWidth sx={{ mb: 3 }}>
                                            <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                                                inputProps={{ sx: { padding: "11px" } }} required type='number' name='price' label="Price" variant='outlined' onChange={this.HandleProcedureChange} />
                                        </FormControl>
                                        <FormControl fullWidth sx={{ mb: 3 }}>
                                            <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                                                inputProps={{ sx: { padding: "11px" } }} required type='number' name='quantity' label="Quantity" variant='outlined' onChange={this.HandleProcedureChange} />
                                        </FormControl>
                                    </div>
                                        

                                    </Col>

                                    <Col>
                                    <div style={{width:"287px"}}>
                                    <FormControl fullWidth sx={{ mb: 3 }}>
                                            <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                                                inputProps={{ sx: { padding: "11px" } }} required type='number' name='tax' label="Tax" variant='outlined' onChange={this.HandleProcedureChange} />
                                        </FormControl>
                                        <FormControl fullWidth sx={{ mb: 3 }}>
                                            <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                                                inputProps={{ sx: { padding: "11px" } }} required name="patientShare" label="Patient Share" variant="outlined" onChange={this.HandleProcedureChange} />
                                        </FormControl>
                                        <FormControl fullWidth sx={{ mb: 3 }}>
                                            <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                                                inputProps={{ sx: { padding: "11px" } }} required name="invoiceNumber" label="Invoice Number" variant="outlined" onChange={this.HandleProcedureChange} />
                                        </FormControl>
                                        {this.state.oralSlected ? (<>
                                            <FormControl fullWidth sx={{ mb: 3 }}>
                                                <InputLabel id="bodysite" style={{ fontSize: "small" }}>Body Stie</InputLabel>
                                                <Select
                                                    required
                                                    labelId="bodysite"
                                                    name="bodySite"
                                                    label="Body Site"
                                                    style={{ height: "45px" }}
                                                    onChange={this.HandleProcedureChange}
                                                >
                                                    <MenuItem value="1-Permanent teeth Maxillary right." style={{ fontSize: "small" }}>1- Permanent teeth Maxillary right.</MenuItem>
                                                    <MenuItem value="2-Permanent teeth Maxillary left." style={{ fontSize: "small" }}>2- Permanent teeth Maxillary left.</MenuItem>
                                                    <MenuItem value="3-Permanent teeth Mandibular right." style={{ fontSize: "small" }}>3- Permanent teeth Mandibular right.</MenuItem>
                                                    <MenuItem value="4-Permanent teeth Mandibular left." style={{ fontSize: "small" }}>4- Permanent teeth Mandibular left.</MenuItem>
                                                    <MenuItem value="5-Deciduous teeth Maxillary right." style={{ fontSize: "small" }}>5- Deciduous teeth Maxillary right.</MenuItem>
                                                    <MenuItem value="6-Deciduous teeth Maxillary left." style={{ fontSize: "small" }}>6- Deciduous teeth Maxillary left.</MenuItem>
                                                    <MenuItem value="7-Deciduous teeth Mandibular right." style={{ fontSize: "small" }}>7- Deciduous teeth Mandibular right.</MenuItem>
                                                    <MenuItem value="8-Deciduous teeth Mandibular left." style={{ fontSize: "small" }}>8- Deciduous teeth Mandibular left.</MenuItem>
                                                    <MenuItem value="11-Upper Right Tooth 1 from the central axis, permanent dentition." style={{ fontSize: "small" }}>11- Upper Right Tooth 1 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="12-Upper Right Tooth 2 from the central axis, permanent dentition." style={{ fontSize: "small" }}>12- Upper Right Tooth 2 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="13-Upper Right Tooth 3 from the central axis, permanent dentition." style={{ fontSize: "small" }}>13- Upper Right Tooth 3 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="14-Upper Right Tooth 4 from the central axis, permanent dentition." style={{ fontSize: "small" }}>14- Upper Right Tooth 4 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="15-Upper Right Tooth 5 from the central axis, permanent dentition." style={{ fontSize: "small" }}>15- Upper Right Tooth 5 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="16-Upper Right Tooth 6 from the central axis, permanent dentition." style={{ fontSize: "small" }}>16- Upper Right Tooth 6 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="17-Upper Right Tooth 7 from the central axis, permanent dentition." style={{ fontSize: "small" }}>17- Upper Right Tooth 7 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="18-Upper Right Tooth 8 from the central axis, permanent dentition." style={{ fontSize: "small" }}>18- Upper Right Tooth 8 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="21-Upper Left Tooth 1 from the central axis, permanent dentition." style={{ fontSize: "small" }}>21- Upper Left Tooth 1 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="22-Upper Left Tooth 2 from the central axis, permanent dentition." style={{ fontSize: "small" }}>22- Upper Left Tooth 2 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="23-Upper Left Tooth 3 from the central axis, permanent dentition." style={{ fontSize: "small" }}>23- Upper Left Tooth 3 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="24-Upper Left Tooth 4 from the central axis, permanent dentition." style={{ fontSize: "small" }}>24- Upper Left Tooth 4 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="25-Upper Left Tooth 5 from the central axis, permanent dentition." style={{ fontSize: "small" }}>25- Upper Left Tooth 5 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="26-Upper Left Tooth 6 from the central axis, permanent dentition." style={{ fontSize: "small" }}>26- Upper Left Tooth 6 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="27-Upper Left Tooth 7 from the central axis, permanent dentition." style={{ fontSize: "small" }}>27- Upper Left Tooth 7 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="28-Upper Left Tooth 8 from the central axis, permanent dentition." style={{ fontSize: "small" }}>28- Upper Left Tooth 8 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="31-Lower Left Tooth 1 from the central axis, permanent dentition." style={{ fontSize: "small" }}>31- Lower Left Tooth 1 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="32-Lower Left Tooth 2 from the central axis, permanent dentition." style={{ fontSize: "small" }}>32- Lower Left Tooth 2 from the central axis, permanent dentition."</MenuItem>
                                                    <MenuItem value="33-Lower Left Tooth 3 from the central axis, permanent dentition." style={{ fontSize: "small" }}>33- Lower Left Tooth 3 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="34-Lower Left Tooth 4 from the central axis, permanent dentition." style={{ fontSize: "small" }}>34- Lower Left Tooth 4 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="35-Lower Left Tooth 5 from the central axis, permanent dentition." style={{ fontSize: "small" }}>35- Lower Left Tooth 5 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="36-Lower Left Tooth 6 from the central axis, permanent dentition." style={{ fontSize: "small" }}>36- Lower Left Tooth 6 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="37-Lower Left Tooth 7 from the central axis, permanent dentition." style={{ fontSize: "small" }}>37- Lower Left Tooth 7 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="38-Lower Left Tooth 8 from the central axis, permanent dentition." style={{ fontSize: "small" }}>38- Lower Left Tooth 8 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="41-Lower Right Tooth 1 from the central axis, permanent dentition." style={{ fontSize: "small" }}>41- Lower Right Tooth 1 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="42-Lower Right Tooth 2 from the central axis, permanent dentition." style={{ fontSize: "small" }}>42-Lower Right Tooth 2 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="43-Lower Right Tooth 3 from the central axis, permanent dentition." style={{ fontSize: "small" }}>43- Lower Right Tooth 3 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="44-Lower Right Tooth 4 from the central axis, permanent dentition." style={{ fontSize: "small" }}>44- Lower Right Tooth 4 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="45-Lower Right Tooth 5 from the central axis, permanent dentition." style={{ fontSize: "small" }}>45- Lower Right Tooth 5 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="46-Lower Right Tooth 6 from the central axis, permanent dentition." style={{ fontSize: "small" }}>46- Lower Right Tooth 6 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="47-Lower Right Tooth 7 from the central axis, permanent dentition." style={{ fontSize: "small" }}>47- Lower Right Tooth 7 from the central axis, permanent dentition.</MenuItem>
                                                    <MenuItem value="48-Lower Right Tooth 8 from the central axis, permanent dentition." style={{ fontSize: "small" }}>48- Lower Right Tooth 8 from the central axis, permanent dentition.</MenuItem>
                                                </Select>
                                            </FormControl>

                                        </>) : null}
                                    </div>
                                        
                                    </Col>
                                </Row>
                                <Row fullWidth>
                                    <Col >

                                        {this.state.vitalSignsArray &&
                                            this.state.vitalSignsArray.length > 0 ? (
                                            <div fullWidth>

                                                <Multiselect
                                                    placeholder="Supporting Informatiom"
                                                    options={this.state.vitalSignSelectArray}
                                                    // selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                                                    onSelect={this.onSelectCategory}
                                                    onRemove={this.onRemoveCategory}
                                                    displayValue="display"
                                                />
                                            </div>
                                        ) : null}
                                    </Col>

                                    <Col >
                                        {this.state.allDiagnosis &&
                                            this.state.allDiagnosis.length > 0 ? (
                                            <div fullWidth>


                                                <Multiselect
                                                    placeholder="Diagnosis"
                                                    options={this.state.allDiagnosisSelect}
                                                    // selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                                                    onSelect={this.onSelectDiagnosis}
                                                    onRemove={this.onRemoveDiagnosis}
                                                    displayValue="view"
                                                />

                                            </div>
                                        ) : null}
                                    </Col>
                                </Row>
                                <div style={{ textAlign: "center" }}>
                                    <Button variant="contained" style={{ marginTop: "30px", backgroundColor: "rgb(97 110 120", width: "100px" }}
                                        onClick={(e) => this.handleSubmitAddNewProcedure(e)
                                        }>Add</Button>
                                </div>




                            </Box>
                        </Modal>
                    </>) : null}
                {this.state.diagnosisModal ? (<>
                    <Modal
                        open={this.state.diagnosisModal}
                        onClose={this.handleCloseDiagnosis}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                        style={{ overflowY: "scroll" }}
                    >
                        <Box sx={styleModal} style={{ width: "30%" }}>
                            <div style={{ marginTop: "20px", textAlign: "center" }}>
                                <FormControl sx={{ mb: 3, width: "70%" }}>
                                    <InputLabel id="typeLabel" style={{ fontSize: "small" }}>Type</InputLabel>
                                    <Select
                                        style={{ height: "45px" }}
                                        required
                                        labelId="typeLabel"
                                        name="type"
                                        label="Type"
                                        onChange={this.HandleDiagnosisChange}
                                    >
                                        <MenuItem value="principal" style={{ fontSize: "small" }}>Principal</MenuItem>
                                        <MenuItem value="secondary" style={{ fontSize: "small" }}>Secondary</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                            <div style={{ textAlign: "center" }}>
                                <FormControl fullWidth sx={{ mb: 3, width: "70%" }}>
                                    <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                                        inputProps={{ sx: { padding: "11px" } }} required name="code"
                                        label="Code" variant="outlined"
                                        onChange={this.HandleDiagnosisChange} />
                                </FormControl>
                            </div>
                            <div style={{ textAlign: "center" }}>
                                <Button variant="contained" style={{ backgroundColor: "rgb(97 110 120", width: "95px" }}
                                    onClick={(e) => this.handleSubmitAddNewDiagnosis(e)
                                    }>Add</Button>
                            </div>

                        </Box>
                    </Modal>
                </>) : null}

                {this.state.vitalSignSelected ? (
                    <>

                        <Modal
                            open={this.state.vitalModal}
                            onClose={this.handleCloseVital}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                            style={{ overflowY: "scroll" }}
                        >
                            <Box sx={styleModal} style={{ width: "30%" }}>
                                {this.state.reasonForVisitSelected ? (
                                    <>
                                        <div style={{ textAlign: "center" }}>
                                            <FormControl style={{ width: "70%" }} sx={{ mb: 3 }}>
                                                <InputLabel id="reason" style={{ fontSize: "small" }}>{this.state.selectedName}</InputLabel>
                                                <Select
                                                    required
                                                    style={{ height: "45px" }}
                                                    labelId="reason"
                                                    name={this.state.selectedName}
                                                    label={this.state.selectedName}
                                                    onChange={this.HandleSupportingInfoChange}
                                                >
                                            <MenuItem value="new-visit" style={{ fontSize: "small" }}>New Visit</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </div>

                                        <div style={{ textAlign: "center" }}>
                                            <Button variant="contained" style={{
                                                backgroundColor: "rgb(97 110 120",
                                                width: "100px"
                                            }}
                                                onClick={(e) => this.handleConfirm(e)}
                                            >Add</Button>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div style={{ textAlign: "center" }}>
                                            <FormControl style={{ width: "70%" }} sx={{ mb: 3 }}>
                                                <TextField InputLabelProps={{ sx: { fontSize: 'small' } }}
                                                    inputProps={{ sx: { padding: "11px" } }} required type='number' name={this.state.selectedName} label={this.state.selectedName} variant='outlined'
                                                    onChange={this.HandleSupportingInfoChange}
                                                />
                                            </FormControl>
                                        </div>

                                        <div style={{ textAlign: "center" }}>
                                            <Button variant="contained" style={{ backgroundColor: "rgb(97 110 120", width: "100px" }}
                                                onClick={(e) => this.handleConfirm(e)}
                                            >Add</Button>
                                        </div>
                                    </>
                                )}

                            </Box>
                        </Modal>


                    </>
                ) :null}
            </div>
        );
    }
}

export default UpdateClaim;